import React from 'react';
import PropTypes from 'prop-types';
import {Button, Dialog, DialogActions, DialogContent, DialogTitle, LinearProgress} from "material-ui";
import {UserForm} from "../../../forms/user";
import {connect} from "react-redux";
import {
    clearUsersError,
    closePostUserFetch,
    closePutUserFetch,
    createUser,
    updateUser
} from "../../../redux/actions/users";
import {snackMessageShow} from "../../../redux/actions/snack_message";

export class UserDialog extends React.Component {

    componentDidMount = () => {
        this.props.initialize();
    };

    handleClose = () => {
        this.props.handleClose();
        setTimeout(() => {
            this.props.initialize();
        }, 10);
    };

    handleSubmit = (values) => {
        if (this.props.user.id === undefined) {
            this.props.createUser(values, this.props.activeCompanyId, this.handleClose);
        } else {
            this.props.updateUser(values, this.handleClose);
        }
    };

    onClickSubmit = () => {
        this.refs.userForm.submit();
    };

    render() {

        const {open, user, errors, isPostUserFetch, isPutUserFetch} = this.props;

        return (
            <Dialog
                open={open}>

                {user.id === undefined ? <DialogTitle id="form-dialog-title">新規ユーザー登録</DialogTitle> : null}
                {user.id !== undefined ? <DialogTitle id="form-dialog-title">ユーザー更新</DialogTitle> : null}


                <DialogContent>
                    <UserForm
                        errors={errors}
                        onSubmit={this.handleSubmit}
                        ref="userForm"
                        initialValues={user}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.handleClose} color="default" disabled={isPostUserFetch}>
                        キャンセル
                    </Button>

                    {user.id === undefined ?
                        <Button onClick={this.onClickSubmit} color="primary" disabled={isPostUserFetch}>
                            新規登録
                        </Button>
                        : null}

                    {user.id !== undefined ?
                        <Button onClick={this.onClickSubmit} color="primary" disabled={isPutUserFetch}>
                            アップデート
                        </Button>
                        : null}

                </DialogActions>
                {isPostUserFetch ? <LinearProgress/> : null}
            </Dialog>
        );
    }
}

UserDialog.propTypes = {
    open: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired,
};

UserDialog = connect(
    (state) => {
        return {
            user: state.users.user,
            errors: state.users.errors,
            isPostUserFetch: state.users.isPostUserFetch,
            activeCompanyId: state.app.activeCompanyId,
        }
    },
    (dispatch) => {
        return {
            initialize: () => {
                dispatch(clearUsersError());
            },
            createUser: (user, companyId, callback) => {
                dispatch(createUser(user, companyId)).then((response) => {
                    setTimeout(() => {
                        dispatch(closePostUserFetch());
                        switch (response.type) {
                            case 'API_AUTH_CREATE_USER_FAIL':
                                dispatch(snackMessageShow('ユーザーの作成に失敗しました'));
                                break;
                            default:
                                dispatch(snackMessageShow('ユーザーを作成しました'));
                                callback();
                        }
                    }, 300);

                });
            },

            updateUser: (user, callback) => {
                dispatch(updateUser(user)).then((response) => {
                    setTimeout(() => {
                        dispatch(closePutUserFetch());
                        switch (response.type) {
                            case 'API_AUTH_UPDATE_USER_FAIL':
                                dispatch(snackMessageShow('ユーザーの更新に失敗しました'));
                                break;
                            default:
                                dispatch(snackMessageShow('ユーザーを更新しました'));
                                callback();
                        }
                    }, 300);

                });
            },
        }
    }
)(UserDialog);


// WEBPACK FOOTER //
// ./src/containers/user/dialog/index.js